/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdatePayMateFirmwareTask
 */
export interface UpdatePayMateFirmwareTask {
    /**
     *
     * @type {string}
     * @memberof UpdatePayMateFirmwareTask
     */
    filename?: string;
    /**
     *
     * @type {string}
     * @memberof UpdatePayMateFirmwareTask
     */
    firmwareContainer?: string;
}

/**
 * Check if a given object implements the UpdatePayMateFirmwareTask interface.
 */
export function instanceOfUpdatePayMateFirmwareTask(
    value: object,
): value is UpdatePayMateFirmwareTask {
    return true;
}

export function UpdatePayMateFirmwareTaskFromJSON(
    json: any,
): UpdatePayMateFirmwareTask {
    return UpdatePayMateFirmwareTaskFromJSONTyped(json, false);
}

export function UpdatePayMateFirmwareTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdatePayMateFirmwareTask {
    if (json == null) {
        return json;
    }
    return {
        filename: json["filename"] == null ? undefined : json["filename"],
        firmwareContainer:
            json["firmwareContainer"] == null
                ? undefined
                : json["firmwareContainer"],
    };
}

export function UpdatePayMateFirmwareTaskToJSON(
    value?: UpdatePayMateFirmwareTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        filename: value["filename"],
        firmwareContainer: value["firmwareContainer"],
    };
}
